module.exports = __webpack_public_path__ + "img/hohlsaum_orange_ral2008.b4d93db7.jpg";